import { Tooltip } from '@mantine/core'

import { NotificationType } from 'src/graphql/types/notifications'

import { NOTIFICATION_TYPE_CONFIG } from './notificationConfig'
import { useNotificationFilter } from './NotificationFilterContext'

const NotificationTitle = () => {
  const { selectedFilter, setSelectedFilter, totalCount } =
    useNotificationFilter()

  return (
    <div className="flex w-full flex-row items-center justify-between">
      <span className="text-sm font-semibold text-doubleNickel-gray-900">
        Notifications{totalCount !== undefined && ` (${totalCount})`}
      </span>
      <div className="flex flex-row items-center gap-1.5">
        {Object.entries(NOTIFICATION_TYPE_CONFIG).map(([type, config]) => (
          <Tooltip key={type} label={config.label}>
            <button
              onClick={() =>
                setSelectedFilter(
                  selectedFilter === (type as NotificationType)
                    ? null
                    : (type as NotificationType)
                )
              }
              className={`flex items-center justify-center rounded p-1.5 transition-colors ${
                selectedFilter === (type as NotificationType)
                  ? 'bg-doubleNickel-brand-100'
                  : 'hover:bg-doubleNickel-gray-100'
              }`}
            >
              <div className="h-4 w-4">{config.icon}</div>
            </button>
          </Tooltip>
        ))}
      </div>
    </div>
  )
}

export default NotificationTitle
